export const action = (actionType, payload, ...otherProps) => ({
  type: actionType,
  payload: payload === null ? null : payload,
  ...otherProps,
});

export const create = actionType => (payload, ...otherProps) => action(actionType, payload, ...otherProps);